import React, { SVGAttributes } from "react";

interface Props extends SVGAttributes<SVGElement> {}

const IconStrikethrough: React.FC<Props> = (props) => {
  return (
    <svg
      viewBox="10 10 20 20"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      {...props}
    >
      <circle cx="20" cy="20" r="7.5" fillOpacity={0} strokeWidth={2} />
      <g strokeLinecap="round" strokeWidth={2}>
        <line x1="11.5" y1="12.5" x2="28.5" y2="27.5" />
        <line x1="28.5" y1="12.5" x2="11.5" y2="27.5" />
      </g>
    </svg>
  );
};

export default IconStrikethrough;
